/**
 * Top navigation model — spec §5.
 *
 * Encoded as data rather than hardcoded JSX because the "is this item clickable?" rule
 * is non-obvious and easy to get wrong:
 *   - WHAT TO SEE is BOTH a link (to its hub) and a dropdown parent.
 *   - THINGS TO DO / STAY & EAT / PLAN YOUR TRIP are dropdown-only — NOT links.
 *
 * Discover is deliberately absent: it is reachable only from the Home hero's
 * "Learn More" button, never the nav (§20.1-17).
 *
 * Child links are stubbed at M0 — their labels get real i18n keys as each section's
 * pages land (M1–M3).
 */

export type NavItem = {
  labelKey: string;
  /** Absent = dropdown parent only, not itself clickable (§5). */
  href?: string;
  children?: { labelKey: string; href: string }[];
};

export const NAV_ITEMS: NavItem[] = [
  { labelKey: 'nav.home', href: '/' },
  {
    labelKey: 'nav.whatToSee',
    href: '/what-to-see',
    children: [
      { labelKey: 'nav.centralMeskheti', href: '/what-to-see/central-meskheti' },
      { labelKey: 'nav.borjomiBakuriani', href: '/what-to-see/borjomi-bakuriani' },
      { labelKey: 'nav.javakheti', href: '/what-to-see/javakheti' },
    ],
  },
  {
    labelKey: 'nav.thingsToDo',
    children: [
      { labelKey: 'nav.activitiesAndTours', href: '/what-to-do/activities-and-tours' },
      { labelKey: 'nav.hikingTrailMap', href: '/what-to-do/hiking-trail-map' },
      { labelKey: 'nav.events', href: '/what-to-do/events' },
      { labelKey: 'nav.agritourism', href: '/what-to-do/agritourism' },
    ],
  },
  {
    labelKey: 'nav.stayAndEat',
    children: [
      { labelKey: 'nav.hotelsResorts', href: '/stay-eat/hotels-resorts' },
      { labelKey: 'nav.guestHouses', href: '/stay-eat/guest-houses' },
      { labelKey: 'nav.wineCulinary', href: '/stay-eat/wine-culinary' },
      { labelKey: 'nav.restaurants', href: '/stay-eat/restaurants' },
    ],
  },
  {
    labelKey: 'nav.planYourTrip',
    children: [
      { labelKey: 'nav.itineraries', href: '/plan/itineraries' },
      { labelKey: 'nav.brochures', href: '/plan/brochures' },
    ],
  },
];
